export class Url {
    static hasQueryParam(param) {
        const url = new URL(window.location.href);
        return !!url.searchParams.get(param);
    }
    static getQueryParams() {
        return new URLSearchParams(window.location.search);
    }
}
